import { atom } from 'recoil';

const mapboxViewModeState = atom({
    key: 'mapboxViewMode',
    default: null
});

export default mapboxViewModeState;
